import React, {FC} from 'react'

import cn from 'classnames/bind'

import s from './LoadingComponent.module.scss'
import SpinnerDots from '../SpinnerDots'
const cx = cn.bind(s)

interface ILoadingComponentProps {
	className?: string
	containerHeight?: number
}

/** LoadingComponent element component.
 * Used to show the spinner during the loading dynamic components */
const LoadingComponent: FC<ILoadingComponentProps> = ({className, containerHeight}) => {
	return (
		<div className={cx('wrapper', className)} style={{height: containerHeight}}>
			<div>
				<SpinnerDots wrapperClassName={cx('spinner')} size="m" position="center" />
			</div>
		</div>
	)
}

LoadingComponent.displayName = 'LoadingComponent'

export default LoadingComponent
